import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import ChargesViewModel from "viewModels/callCenter/search/charges/chargesViewModel";
import { toolbarContext } from "../searchResultsView";

const ChargesToolbarView: ViewComponent<ChargesViewModel> = observer(({ vm }) => {
  return null;
});

registerView(ChargesToolbarView, ChargesViewModel, toolbarContext);
